import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <footer className="py-16 bg-stone-950 border-t border-stone-800" data-id="element-909">
      <div className="max-w-6xl mx-auto px-6" data-id="element-910">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16" data-id="element-911">
          {/* Brand */}
          <div className="md:col-span-4" data-id="element-912">
            <p className="font-serif text-xl text-stone-50 mb-4" data-id="element-913">BlockQuote</p>
            <p className="text-stone-400 max-w-sm leading-relaxed" data-id="element-914">
              Instant group quotes. One-click holds. Direct resort pricing. The
              infrastructure layer for group travel.
            </p>
          </div>

          {/* Platform */}
          <div className="md:col-span-2" data-id="element-915">
            <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-4" data-id="element-916">
              Platform
            </p>
            <ul className="space-y-3" data-id="element-917">
              <li data-id="element-918">
                <button onClick={() => scrollTo('features')} className="text-stone-400 hover:text-stone-50 transition-colors text-sm" data-id="element-919">
                  Product
                </button>
              </li>
              <li data-id="element-920">
                <button onClick={() => scrollTo('pricing')} className="text-stone-400 hover:text-stone-50 transition-colors text-sm" data-id="element-921">
                  Pricing
                </button>
              </li>
              <li data-id="element-922">
                <button onClick={() => scrollTo('proof')} className="text-stone-400 hover:text-stone-50 transition-colors text-sm" data-id="element-923">
                  Case Study
                </button>
              </li>
            </ul>
          </div>

          {/* Demos */}
          <div className="md:col-span-3" data-id="element-924">
            <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-4" data-id="element-925">
              Live Demos
            </p>
            <ul className="space-y-3" data-id="element-926">
              <li data-id="element-927">
                <Link to="/app" className="text-stone-400 hover:text-stone-50 transition-colors text-sm" data-id="element-928">
                  Resort Dashboard
                </Link>
              </li>
              <li data-id="element-929">
                <Link to="/agency" className="text-stone-400 hover:text-stone-50 transition-colors text-sm" data-id="element-930">
                  Agency Portal
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div className="md:col-span-3" data-id="element-931">
            <p className="font-mono text-xs uppercase tracking-widest text-stone-500 mb-4" data-id="element-932">
              Company
            </p>
            <ul className="space-y-3" data-id="element-933">
              <li data-id="element-934">
                <Link to="/deck" className="text-stone-400 hover:text-stone-50 transition-colors text-sm inline-flex items-center gap-2" data-id="element-935">
                  Pitch Deck
                </Link>
              </li>
              <li data-id="element-936">
                <Link to="/sales" className="text-stone-400 hover:text-stone-50 transition-colors text-sm inline-flex items-center gap-2" data-id="element-937">
                  Resort Sales Deck
                  <span className="font-mono text-[10px] text-red-600 border border-red-600/30 px-1.5 py-0.5" data-id="element-938">
                    NEW
                  </span>
                </Link>
              </li>
              <li data-id="element-939">
                <Link to="/onboarding/lomas" className="text-stone-400 hover:text-stone-50 transition-colors text-sm inline-flex items-center gap-2" data-id="element-940">
                  Lomas Onboarding
                  <span className="font-mono text-[10px] text-emerald-500 border border-emerald-500/30 px-1.5 py-0.5" data-id="element-941">
                    PILOT
                  </span>
                </Link>
              </li>
              <li data-id="element-942">
                <button onClick={() => scrollTo('cta')} className="text-stone-400 hover:text-stone-50 transition-colors text-sm" data-id="element-943">
                  Request Pilot
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-stone-800 flex flex-col md:flex-row items-start md:items-center justify-between gap-4" data-id="element-944">
          <p className="font-mono text-xs text-stone-500" data-id="element-945">
            © 2026 BlockQuote. All rights reserved.
          </p>
          <div className="flex gap-6" data-id="element-946">
            <span className="font-mono text-xs text-stone-500 hover:text-stone-400 cursor-pointer transition-colors" data-id="element-947">
              Privacy
            </span>
            <span className="font-mono text-xs text-stone-500 hover:text-stone-400 cursor-pointer transition-colors" data-id="element-948">
              Terms
            </span>
          </div>
        </div>
      </div>
    </footer>;
}